import { render, staticRenderFns } from "./analysisManbingTable.vue?vue&type=template&id=2d0434c1"
import script from "./analysisManbingTable.vue?vue&type=script&lang=js"
export * from "./analysisManbingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports